<template >
    <div class="main-cont">
      <div class="title">
        <form class="searchbar">
          <input v-model="search" class="form-control" type="text" data-action="grow" placeholder="Search">
        </form>
        <div v-if="allItemsLoaded" style="height: unset" class="item-list edit-item-list">
          <List :mode="'edit_delete'" :items="filteredItems" :search="search"/>
        </div>
        <div v-else class="item-list">
          <loader />
        </div>

      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters }             from "vuex";
import { EventBus }                           from "../../eventBus";
import List                                   from '../builder/List.vue';
import { HalfCircleSpinner }                  from 'epic-spinners'
import loader                                 from '../widgets/loader.vue'

export default {
  name: 'Items',
  components:{
    HalfCircleSpinner,
    List,
    loader
  },
  computed: {
    ...mapGetters([
      'getFetchedItems',
      'allItemsLoaded'
    ]),
    filteredItems: function(){
      var items = this.getFetchedItems
      if(this.getFetchedItems[0].id < 20){
        items = items.reverse()  
      }
      
      this.setItems(this.getFilteredList(items, this.activeFiltersV2))
      return  this.getFilteredList(items, this.activeFiltersV2)
    },
  },
  data() {
    return {
      search: '',
      type: '',
      items: 'empty',
      categoryChosen: false,
      currentCategory: '',
      category: '',
      activeFiltersV2: {}
    }
  },
  methods: {
    ...mapActions([
      'setPartAttribs',
      'setCurrentPartType',
      //'setItems',
      'setItem'
    ]),
    setItems(){
      this.items = this.getFetchedItems
    },
    getFilteredList(items, attribs) {
            var result = []
            if(items && items !== null && typeof(attribs) == 'object' && Object.keys(attribs).length >0){
                console.log('filtering ', items, ' with attribs ', attribs)
                items.map(item => {
                if(attribs[item.type]){
                    Object.keys(attribs[item.type]).map(option => {
                    console.log(option)
                    if(option == 'RAM_Type' && item.type == 'cpu'){
                        option = 'ram'
                    }
                    if(item.compat[option]){
                        console.log(item.compat[option])
                    }
                    if(item.specs[option]){
                        console.log(item.specs[option])
                    }
                    console.log(option)
                    })
                }
                })
            }
            if(items && items !== null && items.length >0){
                if (this.search && this.search !== "") {
                    items.map((item) => {
                        if(item.model.toLowerCase().includes(
                            this.search.toLowerCase())
                            || item.asin.toLowerCase().includes(this.search.toLowerCase())
                            || JSON.stringify(item).toLowerCase().includes(this.activeFilters)){
                                result.push(item)
                            }
                    });
                } 
                if(result.length >0){
                    if(this.getCompatibleMode == true){
                        return result.filter((item) => {
                            return this.checkPartCompat({compatTable: this.getCompatLib, type: item.type, asin: item.asin}) !==false
                        })
                    }
                    else {
                        return result
                    }
                }
                if(result.length == 0){
                    if(this.getCompatibleMode == true){
                        return items.filter((item) => {
                            return this.checkPartCompat({compatTable: this.getCompatLib, type: item.type, asin: item.asin}) !==false
                        })
                    }
                    else {
                        return items
                    }
                }
            }
            else return this.getFetchedItems;
        },
    popup(item){
      this.setItem(item)
      this.$router.push('editpart?type='+item.type).catch(()=>{})
    },
    getType(){
      this.type = this.$route.query.type 
      return this.type
    },
  },
  mounted(){
    // this.getType();
        // this.setItems(this.items)
        this.getType();
        EventBus.$on('frequency', (frequencyIndex) => {
            this.frequencyGHZ = parseInt(parseFloat(frequencyIndex)*100);
            parseInt(this.frequencyGHZ)
            console.log('frequency emited, frequencyGHZ: '+this.frequencyGHZ)
        });
        EventBus.$on('emitTypeChange', () => {
            this.setItems()
            this.search = ''
        });
        EventBus.$on('sortApplied', () => {
            this.setItems()
        });
        EventBus.$on('extendListResponse', (bool) => {
            this.listExtended = bool        
        })
  },
  created(){
    this.setCurrentPartType(this.getType())
    
  },
  beforeDestroy(){
    EventBus.$emit('clearCategory')
  }
}
</script>

<style scoped>
@import '../../assets/css/custom.css';
@import '../../assets/css/dashboard.css';
@import '../../assets/css/toolkit-inverse.css';
::-webkit-scrollbar { 
   display:unset !important; 
}
h4 {
  text-transform: capitalize !important;
  padding: 10px;
  padding-left: 0px;
  color: #1997c6 !important;
}
.label {
  border-bottom: 1px solid #9198aa;
  margin-bottom: 14px;
}
.label h4{
  height: 33px;
  font-size: 15pt;
  font-weight: normal;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.main-cont label{
  color: #B2B3B4;
  text-transform: uppercase;
}
.top-block {
  padding-right: 14px;
  padding-left: 14px;
  vertical-align: top;
  display: inline-block !important;
}
.category {
  border-radius: 6px;
  margin-left: 10px;
  padding: 5px 10px;
  border: 1px solid #B2B3B4;
  display: inline-block;
}
.category:hover{
  cursor: pointer;
  border: 1px solid #1997c6;
  color: #1997c6;
}
.category-active{
  border: 1px solid #1997c6;
  color: #1997c6;
}
.icon-minus {
  display: none;
}
.icon-minus:hover {
  color: #e64759 !important;
}
.inCompareList {
  display: block !important;
}
.inCompareList-hide-add-btn {
  display: none;
}
.checked {
  color: #1bc98e !important;
}
.item-list {
  padding-left: 10px;
}
.searchbar {
  margin: 10px;
}
</style>